export default "__VITE_ASSET__hr24LjmO__"